import React from "react";
import { useTranslation } from "react-i18next";
import { template } from "lodash";
import parse from "html-react-parser";

import {
    IWorkflowStep,
    IWorkflowWithData,
} from "store/workflows/workflows-types";

import "./Username.less";

interface Props {
    workflow: IWorkflowWithData<IWorkflowStep, any>;
}

const Username: React.FC<Props> = ({ workflow }: Props) => {
    const { t } = useTranslation();

    return workflow.createdBy ? (
        <div className="workflow-modal__username">
            {parse(
                template(t("workflow.createdBy"))({
                    username: workflow.createdBy,
                    workflow: "",
                })
            )}
        </div>
    ) : (
        <></>
    );
};

export default Username;
